/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeamMemberRole } from './TeamMemberRole';
import {
    TeamMemberRoleFromJSON,
    TeamMemberRoleFromJSONTyped,
    TeamMemberRoleToJSON,
    TeamMemberRoleToJSONTyped,
} from './TeamMemberRole';

/**
 * 
 * @export
 * @interface InviteTeamMemberBody
 */
export interface InviteTeamMemberBody {
    /**
     * Email of user to invite
     * @type {string}
     * @memberof InviteTeamMemberBody
     */
    email?: string;
    /**
     * User ID to invite (alternative to email)
     * @type {string}
     * @memberof InviteTeamMemberBody
     */
    userId?: string;
    /**
     * 
     * @type {TeamMemberRole}
     * @memberof InviteTeamMemberBody
     */
    role?: TeamMemberRole;
}



/**
 * Check if a given object implements the InviteTeamMemberBody interface.
 */
export function instanceOfInviteTeamMemberBody(value: object): value is InviteTeamMemberBody {
    return true;
}

export function InviteTeamMemberBodyFromJSON(json: any): InviteTeamMemberBody {
    return InviteTeamMemberBodyFromJSONTyped(json, false);
}

export function InviteTeamMemberBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): InviteTeamMemberBody {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'role': json['role'] == null ? undefined : TeamMemberRoleFromJSON(json['role']),
    };
}

export function InviteTeamMemberBodyToJSON(json: any): InviteTeamMemberBody {
    return InviteTeamMemberBodyToJSONTyped(json, false);
}

export function InviteTeamMemberBodyToJSONTyped(value?: InviteTeamMemberBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'userId': value['userId'],
        'role': TeamMemberRoleToJSON(value['role']),
    };
}

